import React, { Component } from 'react'
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import axios from 'axios'
import Moment from 'react-moment'
import PropTypes from 'prop-types'
import debounce from 'lodash.debounce';

import SearchTinglystDokument from './MatrikkelenhetDetails/Grunnbok/SearchTinglystDokument.jsx'
import UtskriftBestillingList from './MatrikkelenhetDetails/Grunnbok/UtskriftBestillingList.jsx'
import MatrikkelSearchEvents from './MatrikkelSearchEvents.js'
import Cookie from '../../utils/Cookie'
import ResultList from './ResultList/ResultList.jsx'
import common_en from "../../locales/en/common.json";
import common_no from "../../locales/no/common.json";

import './MatrikkelSearch.scss'

class MatrikkelSearch extends Component {
 state = {
   domainKlasse: null,
   matrikkelBubbleId: null,
   results: [],
   query: ''
 }

  UNSAFE_componentWillMount = () => { 
   Moment.globalFormat = "DD.MM.YYYY";
   Moment.globalParse = "YYYY.MM.DDTHH:mm:ss";
   Moment.globalFilter = (d) => {
     return d == "Invalid date" ? null : d;
   }

   if (this.props.domainKlasse != null && this.props.matrikkelBubbleId) {
     this.setState({domainKlasse: this.props.domainKlasse, matrikkelBubbleId: this.props.matrikkelBubbleId})
      }

      this.onChangeDebounced = debounce(this.onChangeDebounced, 300)

 }

 UNSAFE_componentWillReceiveProps = (nextProps) => {
  if (this.search) this.search.value = null
  this.setState({domainKlasse: nextProps.domainKlasse, matrikkelBubbleId: nextProps.matrikkelBubbleId})
 }

 UNSAFE_componentWillUpdate = (nextProps, nextState) => {
   var nextStateHasResults = nextState.results.length > 0 || nextState.domainKlasse != null
   if (nextStateHasResults != this.hasResults()) {
     this.onResultChanged(nextStateHasResults);
   }
 }

 disableEnterKey = (event) => {
   if (event.key == "Enter") event.preventDefault()
 }

 onInputFocus = () => {
   if (this.state.results.length > 0) return
   var searchHistory = Cookie.getProperty("searchHistory")
   if (searchHistory != null) this.setState({results:searchHistory})

   if (this.props.isSearchTinglystDokumentEnabled) {
    this.props.onEvent({ type: MatrikkelSearchEvents.ResetMatrikkelSearch })
  }
  if (this.props.isUtskriftBestillingEnabled) {
    this.props.onEvent({ type: MatrikkelSearchEvents.ResetMatrikkelSearch })
  }
 }

 onInputChange = () => {
   this.setState({
     query: this.search.value,
     domainKlasse: null,
     matrikkelBubbleId: null
     })

     this.onChangeDebounced()
}

    onChangeDebounced = () => {
        if (!this.state.query || this.state.query.length < 2) {
            this.setState({ matrikkelBubbleId: null, results: [] })
            return
        }

        this.finnEiendom();
    }

 handleResultSelected = (domainKlasse, matrikkelBubbleId) => {
   if (domainKlasse == null) {
    this.setState({domainKlasse: domainKlasse, matrikkelBubbleId: matrikkelBubbleId, results: []})
   } else {
    this.setState({domainKlasse: domainKlasse, matrikkelBubbleId: matrikkelBubbleId})
   }
 }

 finnEiendom = () => {
     axios.get(`${this.props.settings.baseUrl}api/search`, {
         params: {
           query: this.state.query,
           token: this.props.token
         }
   })
   .then(({data}) => {
     this.setState({results: data.hits})
   })
 }

 onReset = () => {
   this.setState({query: '', results:[]})
  this.props.onEvent({ type: MatrikkelSearchEvents.ResetMatrikkelSearch })
 }

 hasResults = () => {
   return !this.props.isSearchTinglystDokumentEnabled && !this.props.isUtskriftBestillingEnabled && (this.state.results.length > 0 || this.state.domainKlasse != null)
 }

 onResultChanged = hasResults => {
  this.props.onEvent({
    type: MatrikkelSearchEvents.ResultChanged,
    data: {
      hasResults: hasResults
    }
  })
 }

 onNavigateBack = () => {
   if (this.props.isSearchTinglystDokumentEnabled) this.props.onEvent({ type: MatrikkelSearchEvents.HideSearchTinglystDokument })
   if (this.props.isUtskriftBestillingEnabled) this.props.onEvent({ type: MatrikkelSearchEvents.HideUtskriftBestilling })
 }

 render() {
   return (
    <I18nextProvider i18n={i18next}>
        <div className={`matrikkelsearch ${this.props.hidesearch ? 'nosearchbox' : ''} ${this.state.domainKlasse || this.props.isSearchTinglystDokumentEnabled || this.props.isUtskriftBestillingEnabled ? 'hasresults' : ''} ${this.hasResults() ? '' : 'noresults'}`}>
        <form>
          { !this.props.hidesearch &&
          <div className="searchbox">
            <span className="icon"><i className="fa fa-search"></i></span>
            <input className={`${this.hasResults() ? '' : 'noresults'}`} autoComplete="off" placeholder={i18next.t('common:searchbox.placeholder')} ref={input => this.search = input} onKeyPress={this.disableEnterKey} onChange={this.onInputChange} onFocus={this.onInputFocus} />
            { this.hasResults() && <span className="icon right" onClick={this.onReset}><i className="fa fa-times"></i></span>}
          </div>
          }
        </form>
        { this.props.isSearchTinglystDokumentEnabled && <ul className="resultdetails"><SearchTinglystDokument kommunenummer="" token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onNavigateBack={this.onNavigateBack} /></ul>}
        { this.props.isUtskriftBestillingEnabled && <ul className="resultdetails"><UtskriftBestillingList token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onNavigateBack={this.onNavigateBack} /></ul>}
        { !this.props.isSearchTinglystDokumentEnabled && !this.props.isUtskriftBestillingEnabled && !this.props.isut && <ResultList domainKlasse={this.state.domainKlasse} matrikkelBubbleId={this.state.matrikkelBubbleId} results={this.state.results} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onResultSelected={this.handleResultSelected} /> }
      </div>
     </I18nextProvider>
   )
 }
}

MatrikkelSearch.propTypes = {
  onEvent: PropTypes.func
}

export default MatrikkelSearch